<template>
    <div class="row">
        <div class="edit-journey my-4 px-4 container">
            <div class="row mb-4">
                <div class="col-12">
                    <form ref="form" label-position="left" class="userform">
                        <h2 class="mb-4 mt-3 text-white">Your Journey</h2>
                        <form-errors :errors="errors" aria-invalid='true'></form-errors>
                        <app-error :error="defaultError" aria-invalid='true'></app-error>
                        <app-success :success="defaultSuccess" aria-invalid='true'></app-success>
                        <div id="from-to-container" class="d-flex">
                            <div class="flex-fill pr-3">
                                <div class="d-flex">
                                    <div class="from-to-input-group">
                                        <p class="from-to-input-group-text"><strong>From</strong></p>
                                    </div>
                                    <div class="flex-fill">
                                        <auto-complete :disabled="false" placeholder="Enter your origin" v-model="form.origin"></auto-complete>
                                    </div>
                                </div>
                                <div id="from-to-input-separator"></div>
                                <div class="d-flex">
                                    <div class="from-to-input-group">
                                        <p class="from-to-input-group-text"><strong>To</strong></p>
                                    </div>
                                    <div class="flex-fill">
                                        <auto-complete :disabled="false" placeholder="Enter your destination" v-model="form.destination"></auto-complete>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div id="switch-from-to" class="c-pointer" @click="switchFromTo">
                                    <svg-icon name="switch-from-to-icons" width="9" />
                                </div>
                            </div>
                        </div>
                        <div class="d-flex w-100">
                            <b-form-group class="flex-grow-1">
                                <b-form-radio-group
                                    :disabled="formLock"
                                    id="journey-type-buttons"
                                    v-model="journeyTypeModel"
                                    :options="journeyTypeOptions"
                                    buttons
                                    name="journey-type"
                                    @change="onJourneyTypeChange">
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                        <div class="mt-3">
                            <b-form-group
                                label="Outbound"
                                label-for="outbound" class="planner-datepicker">
                                <svg-icon class="time-picker-calendar c-pointer calendar-icon-home" name="time-picker-calendar-icon" width="18"></svg-icon>
                                <datetime
                                    :week-start="1"
                                    :min-datetime="minimumDate"
                                    :max-datetime="maximumDate"
                                    v-model="form.out_time"
                                    :minute-step="5"
                                    type="datetime"
                                    input-id="outbound-input"
                                    placeholder="choose a date and time"
                                    input-class="form-control ajp-form-control datetime-picker-control c-pointer"
                                    class="theme-red">
                                </datetime>
                            </b-form-group>
                            <span class="form-error"  v-if="errors.out_time"> {{errors.out_time}} </span>
                            <b-form-group
                                v-if="journeyTypeModel == 'return'"
                                label="Return"
                                label-for="return" class="planner-datepicker">
                                <svg-icon class="time-picker-calendar c-pointer calendar-icon-home" name="time-picker-calendar-icon" width="18" />
                                <datetime
                                    :week-start="1"
                                    :min-datetime="returnMinimumDate"
                                    :max-datetime="maximumDate"
                                    v-model="form.return_time"
                                    type="datetime"
                                    input-id="return-input"
                                    placeholder="choose a date and time"
                                    input-class="form-control ajp-form-control datetime-picker-control c-pointer"
                                    class="datetime-picker theme-red">
                                </datetime>
                            </b-form-group>
                        </div>
                        <b-button class="full-green-btn mt-3" @click="search" :disabled="formLock">
                            <span v-if="!formLock">Update routes <svg-icon v-if="brand != 'sestran'" name="forward" ></svg-icon></span>
                            <b-spinner v-if="formLock" type="grow" label="Spinning" style="width: 24px; height: 24px;" class="app-spinner-white"></b-spinner>
                        </b-button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mutationsMapping from '@/store/mutations-mapping'
import {
    mapState,
    mapMutations,
    mapActions,
} from 'vuex'
import moment from 'moment'
import AutoComplete from '@/components/AutoComplete.vue'
import { journeyTypeOptions } from '@/store/options'
import FormErrors from '@/components/FormErrors.vue'
import AppError from '@/components/AppError.vue'
import AppSuccess from '@/components/AppSuccess.vue'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Home',
    components: {
        AutoComplete,
        FormErrors,
        AppError,
        AppSuccess,
    },
    data() {
        return {
            journeyTypeModel: 'single',
            journeyTypeOptions,
            placeholder: 'Start typing an address or postcode',
            outboundError: false,
            formLock: false,
            brand: whitelabel.brand,
        }
    },
    computed: {
        ...mapState([
            'form',
            'journeyType',
            'errors',
            'defaultError',
            'defaultSuccess',
            'user',
        ]),
        minimumDate() {
            return moment().toISOString()
        },
        maximumDate() {
            return moment().add(6, 'months').toISOString()
        },
        returnMinimumDate() {
            return moment(this.form.out_time).toISOString()
        },
    },
    mounted() {
        this.initFormValues()

        if (this.form.return_time) {
            this.journeyTypeModel = 'return'
        }
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'searchQuery',
        ]),
        switchFromTo() {
            if (this.formLock) return

            const currentOrigin = this.form.origin
            const currentDestination = this.form.destination

            this.form.destination = currentOrigin
            this.form.origin = currentDestination
        },
        search() {
            this.searchQuery({
                params: this.prepareInput(),
                router: this.$router,
            })
        },
        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },
        prepareInput() {
            const form = { ...this.form }
            delete form.arrive_time
            form.out_time = this.formatDate(this.form.out_time)
            if (form.return_time) {
                form.return_time = this.formatDate(this.form.return_time)
            } else {
                delete form.return_time
            }

            if (this.user) {
                form.has_car_access = this.user.profile.has_car_access
                form.railcard = this.user.profile.railcard
                form.has_concessionary_pass = this.user.profile.has_concessionary_pass
                form.user_age = this.user.profile.user_age
            }

            return form
        },
        formatDate(date) {
            return moment(date).format('YYYY/MM/DD HH:mm:ss')
        },
        onJourneyTypeChange(e) {
            if (e === 'single') {
                this.form.return_time = null
            }
        },
    },

}
</script>
